export class PesquisaDadosEntidade {
    public CD_FUNDACAO: string | null;
    public CD_EMPRESA: string | null;
    public CD_PLANO: string | null;
    public CD_SIT_PLANO: string | null;
    public NUM_MATRICULA: string | null;
    public NOME: string | null;
}
